import { createTranslations } from '@npco/common-utils-translations'

export const noDebitCardTransactionsTranslations = createTranslations({
  noDebitCardTransactionsDescription:
    'Looks like there aren’t any purchases yet. Any future transactions will appear here.',
})
